import { propertyAssetTenantService } from '@/services/api/propertyAssetTenant.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyAssetTenantModel } from '@/models/api/propertyAssetTenant.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_ASSET_TENANT_MODULE = "api/propertyAssetTenant";

// ACTIONS
export const GET_ALL_PROPERTY_ASSET_TENANT = 'getAllPropertyAssetTenant';
export const CREATE_PROPERTY_ASSET_TENANT = 'createPropertyAssetTenant';
export const GET_PROPERTY_ASSET_TENANT = 'getPropertyAssetTenant';
export const UPDATE_PROPERTY_ASSET_TENANT = 'updatePropertyAssetTenant';
export const UPDATE_PROPERTY_ASSET_TENANT_STATUS = 'updatePropertyAssetTenantStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_ASSET_TENANT_SUCCESS = "allPropertyAssetTenantSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_ASSET_TENANT_SUCCESS = "getPropertyAssetTenantSuccess";

export const actions = {
    [GET_ALL_PROPERTY_ASSET_TENANT]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        propertyAssetTenantService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_ASSET_TENANT_SUCCESS, {data: result});
                commit(SUCCESS);
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_ASSET_TENANT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAssetTenantService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET_TENANT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_ASSET_TENANT]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyAssetTenantService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_ASSET_TENANT_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_ASSET_TENANT]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyAssetTenantService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET_TENANT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_ASSET_TENANT_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyAssetTenantService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_ASSET_TENANT, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_ASSET_TENANT_SUCCESS](state, {data}) {
        let propertyAssetTenant = data.data || [];
        state.list.data = propertyAssetTenant;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyAssetTenant.map(item => propertyAssetTenantModel(item));
        }
    },
    [GET_PROPERTY_ASSET_TENANT_SUCCESS](state, data) {
        state.details = propertyAssetTenantModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
